module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-03.7d327cb7.svg";